import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=a3054572&scoped=true&"
import script from "./BackButton.vue?vue&type=script&lang=ts&"
export * from "./BackButton.vue?vue&type=script&lang=ts&"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=a3054572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3054572",
  null
  
)

export default component.exports